module.exports = __webpack_public_path__ + "img/sjb-63_100.prt.6987357e.jpg";